import React, { createContext, useContext, useState } from 'react'

import { post } from '../deprecated/features/base'

type EntryType = any

interface ReportIssueContextType {
	displayReportIssueCard: boolean
	entry: EntryType | null
	showReportIssueCard: (entry: EntryType) => void
	hideReportIssueCard: () => void
	postIssue: (entry: EntryType, description: string) => Promise<void>
}

const ReportIssueContext = createContext<ReportIssueContextType | undefined>(
	undefined
)

export const ReportIssueProvider: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => {
	const [displayReportIssueCard, setDisplayReportIssueCard] =
		useState<boolean>(false)
	const [entry, setEntry] = useState<EntryType | null>(null)

	const showReportIssueCard = (entry: EntryType) => {
		setEntry(entry)
		setDisplayReportIssueCard(true)
	}

	const hideReportIssueCard = () => {
		setDisplayReportIssueCard(false)
		setEntry(null)
	}

	const postIssue = async (entry: EntryType, description: string) => {
		const body = { runId: entry.runId, entryId: entry.entryId, description }
		try {
			const res = await post('/api/v2/issue', body)
			const data = await res.json()
			if (data.error) throw data.error
			return data
		} catch (error) {
			console.error('Failed to post issue:', error)
			throw error
		}
	}

	return (
		<ReportIssueContext.Provider
			value={{
				displayReportIssueCard,
				entry,
				showReportIssueCard,
				hideReportIssueCard,
				postIssue,
			}}
		>
			{children}
		</ReportIssueContext.Provider>
	)
}

export const useReportIssue = (): ReportIssueContextType => {
	const context = useContext(ReportIssueContext)
	if (context === undefined) {
		throw new Error(
			'useReportIssue must be used within a ReportIssueProvider'
		)
	}
	return context
}
